import Api from "./HandleErrorApi";

class UserPromoApi {
    api = new Api();

    async getAll(page = 1)
    {
        return this.api.get('promocode', {page});
    }

    async create(data)
    {
        return this.api.post('promocode', data);
    }

    async changeStatus(code)
    {
        return this.api.post('promocode/switch', {code});
    }
}

export default new UserPromoApi();
